module.exports = __webpack_public_path__ + "img/2004.ee88c841.jpg";